import store from '@/store'

export default {
	inserted (el, bindings) {
		const { value } = bindings
		const all_permission = '*:*:*'
		const permissions = store.getters && store.getters.permissions

		if (value && value instanceof Array && value.length > 0) {
			const permissionFlag = value
			const hasPermissions = permissions && permissions.some(permission => {
				return all_permission === permission || permissionFlag.includes(permission)
			})

			if (!hasPermissions) {
				// 隐藏
				el.parentNode && el.parentNode.removeChild(el)

				// 禁用
				// el.classList.add('is-disabled')
				// el.setAttribute('disabled', '')
			}
		} else {
			throw new Error('请设置操作权限标签值')
		}
	}
}
